import './Ads.css';

function Ads() {
  return (
    <>
      <div className="ads">
        <a href="http://www.froniudev.pl/" target="_blank" rel="noreferrer">
          <img src="https://via.placeholder.com/300x600/ffe9e5/262626?text=Place+For+Your+Ads" alt="Place for yours ads."></img>
        </a>
      </div>
    </>
  );
}

export default Ads;
